import Cookies from 'js-cookie';

/**
 * Name of the cookie the API's JwtStrategy reads as a fallback extractor for
 * requests that cannot carry an Authorization header (`req.cookies.accessToken`).
 */
const COOKIE_NAME = 'accessToken';

/**
 * Prod: the API (`api.community-coaching.com`) and the tenant web apps
 * (`<tenant>.community-coaching.com`) are subdomains of the same registrable
 * domain — a `.community-coaching.com` cookie is shared across them (same-site),
 * so native media requests to the API carry it. Dev (localhost): host-only
 * cookie, still reaches the API on another port (cookies ignore the port).
 */
function cookieDomain(): string | undefined {
  return window.location.hostname.endsWith('community-coaching.com')
    ? '.community-coaching.com'
    : undefined;
}

/**
 * Mirror the current OIDC access token into the `accessToken` cookie.
 *
 * Media (`<img>`/`<video>`/`<audio>`/download links pointing at `/files/…`) is
 * loaded through native browser requests that cannot set an `Authorization`
 * header, so file streaming authenticates via this cookie (the API's cookie
 * extractor). Under OIDC the token lives in JS storage, so we keep the cookie in
 * sync on every token change and clear it on logout. It is a session cookie
 * (no expiry → cleared on browser close) and is refreshed on each token update.
 */
export function syncMediaAuthCookie(token: string | null): void {
  const domain = cookieDomain();
  if (!token) {
    Cookies.remove(COOKIE_NAME, {domain, path: '/'});
    return;
  }
  Cookies.set(COOKIE_NAME, token, {
    domain,
    path: '/',
    secure: window.location.protocol === 'https:',
    sameSite: 'Lax',
  });
}
